export const YYYY_MM_DD = 'YYYY-MM-DD'
export const YYYY_MM_DD_LOWER = 'yyyy-MM-dd'
export const DAY_OF_WEEK_ISO = 'E'
export const DAY_OF_WEEK_ISO_LOWER = 'e'
export const UNIX_MILLISECOND_TIMESTAMP = 'x'
export const YYY_MM_DD_HH_MM_A = `${YYYY_MM_DD} hh:mm a`
export const LOCALIZED_TIME = 'LT'
export const HHmm = 'HH:mm'
